<template>
  <div class="container">
    <div class="row flex-wrap gutter-sm">
      <component
        :is="cardComponent"
        v-for="(card, index) in blok"
        :key="card.id"
        :blok="card"
        :card-type="useFeaturedCard && index === 0 ? 'feature' : 'vertical'"
        :class="
          useFeaturedCard && index === 0
            ? 'xs-12 sm-12'
            : 'xs-12 xsxl-6 sm-6 md-4'
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CustomCardStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: CustomCardStoryblok[]
  contentType: string
  useFeaturedCard?: boolean
}>()
const cardComponent = computed(() =>
  slugToComponentTypeName(props.contentType, 'Card'),
)
</script>

<style lang="less" scoped>
// stuff
</style>
